<template>
  <header>
    <router-link to="/" class="nounderline">
      <SVGLogo />
      <span>{{ $t('header.title') }}</span>
    </router-link>
    <nav>
      <ul>
        <li v-for="(item, index) in computedPrimaryNavigation" :key="`primary-nav-${index}`">
          <router-link :to="item.url">{{ item.label }}</router-link>
        </li>
      </ul>
    </nav>
    <nav>
      <ul>
        <li><a
          href="mailto:bigna.bernet@vsa.zh.ch?cc=ducceschi@ditoy.com&subject=SAV-Tool%20v2%20Report:%20[Ihr%20Anliegen]&body=SAV-ID%20(falls%20notwendig):%0A[Erfassen%20Sie%20die%20SAV-ID%20hier]%0A%0ABetriebssystem,%20aktueller%20Browser%20und%20Browserversion:%0A[z.b:%20Windows%2011,%20Chrome%20136]%0A%0AFehlerbeschreibung:%0A[Erfassen%20Sie%20Ihre%20Beschreibung%20hier]"
          >
          Feedback
          </a>
        </li>
        <li><a href="/Resources">Ressourcen</a></li>
        <li><router-link to="/support">Support</router-link></li>
        <li tabindex="0" :title="userName">
          <Icon name="profile" />
          <ul>
            <li><router-link to="/user">Profil</router-link></li>
            <li @click="$emit('signout')">Abmelden</li>
          </ul>
        </li>
      </ul>
    </nav>

  </header>
</template>

<script>
  import SVGLogo from '@/assets/svg/app-logo.svg?inline';
  import Icon from '@/components/ui/Icon';
  import { Store } from '@/store';

  export default {
    name: 'Header',
    components: {
      SVGLogo,
      Icon,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      userName() {
        return Store.name;
      },
      computedPrimaryNavigation() {
        const labels = this.$i18n.t('header.navigation.primary');
        const out = [];
        if (Store.permissions.branchCanCreate) {
          out.push({ url: '/branches', label: labels.branches });
        }
        if (Store.permissions.inquiryCanViewAssigned || Store.permissions.inquiryCanViewAssigned) {
          out.push({ url: '/inquiries', label: labels.inquiries });
        }
        if (Store.permissions.userCanCreate) {
          out.push({ url: '/users', label: labels.users });
        }
        if (Store.permissions.branchCanCreate) {
          out.push({ url: '/statistics', label: labels.statistics });
        }
        return out;
      },
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
    },
  };
</script>

<style lang="scss">
  @import '~scss/animations';
  @import '~scss/mixins';
  @import '~scss/variables';

  header {
    background-color: $color-blue-solid-100;
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px;
    user-select: none;

    & > a {
      display: flex;
      align-items: center;
      text-decoration: none;

      & > svg {
        width: 38px;
        height: auto;
        margin-right: 12px;
      }

      & > span {
        @include font-logo;
        text-decoration: none;
      }
    }

    a {
      position: relative;
      @include font-main-navigation;
      color: $color-white-alpha-60;
      transition: color $default-transition;
      text-decoration: none;
      text-transform: uppercase;
      outline: 0;

      &:after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 1px;
        width: calc(100% - 2px);
        height: 2px;
        transform: scale(0, 1);
        background-color: transparent;
        border-radius: 2px;
        transition: background-color $default-transition, transform $default-transition;
      }

      &:hover, &:focus, &.router-link-exact-active, &.router-link-active {
        color: $color-white-solid-10;
        &:after {
          transform: scale(1, 1);
          background-color: $color-white-solid-10;
        }
      }

      &.nounderline:after {
        display: none;
      }
    }

    ul {
      list-style-type: none;
      display: inline-flex;
      align-items: center;
    }

    & > nav:first-of-type {
      & > ul > li {
        margin-right: 48px;
        &:last-of-type {
          margin-right: 0;
        }
      }
    }

    & > nav:last-of-type {
      & > ul > li {
        position: relative;
        margin-right: 24px;
        color: $color-white-alpha-60;
        transition: color $default-transition;
        outline: 0;

        &:last-of-type {
          margin-right: 0;
          &:hover, &:focus, &:focus-within {
            color: $color-white-solid-10;
          }
        }

        svg {
          position: relative;
          top: 3px;
          width: 32px;
          height: 32px;
        }

        & > ul {
          position: absolute;
          right: 0;
          bottom: 0;
          display: none;
          z-index: 1500;
        }

        &:focus-within, &:focus {
          ul {
            display: block;
            position: absolute;
            right: 0;
            bottom: -2px;
            min-width: 100px;
            transform: translate(0, 100%);
            background-color: $color-white-solid-10;
            box-shadow: $box-shadow-2;
            list-style-type: none;
            margin: 0;
            padding: 2px;
            border-radius: $default-border-radius;

            &:after {
              position: absolute;
              content: '';
              top: -6px;
              right: 8px;
              border-left: 8px solid transparent;
              border-right: 8px solid transparent;
              border-bottom: 8px solid $color-white-solid-10;
            }

            & > li {
              margin: 0;
              padding: 8px;
              @include font-body-small;
              color: $color-black-solid-100;
              border-radius: $default-border-radius;
              will-change: background-color;
              transition: background-color 0.2s linear;

              & > a {
                display: block;
                font-family: inherit;
                font-size: inherit;
                color: inherit;
                font-weight: inherit;
                text-transform: none;
                text-decoration: none;
                &:after { display: none; }
              }

              &:hover {
                background-color: $color-black-alpha-05;
              }
            }
          }
        }
      }
    }

  }
</style>
